export default __webpack_public_path__ + "static/media/BE-Student.97bcbcf4.png";